import { Component, OnInit } from '@angular/core';

import { BitfMatSidenavService } from '@common/libs/bitforce/core/services/sidenav/material/bitf-mat-sidenav.service';

import { EBitfCloseEventStatus } from '@common/enums';
import { APP_VERSION, BUILD_DATE } from '@env/version';
import { NAVIGATION_MENU } from '@common/constants';

@Component({
  selector: 'soh-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
})
export class SidenavMenuComponent implements OnInit {
  appVersion = APP_VERSION;
  appBuildAt = BUILD_DATE;

  navigationMenu = NAVIGATION_MENU;

  constructor(private bitfMatSidenavService: BitfMatSidenavService) {}

  ngOnInit(): void {}

  closeSidenav() {
    this.bitfMatSidenavService.close({ status: EBitfCloseEventStatus.CLOSE });
  }
}
